document.addEventListener('DOMContentLoaded', function () {
  // тільки для цієї сторінки
  if (window.location.pathname !== '/products/mini-runes-necklaces-sterling-silver') {
    return;
  }

  document.body.classList.add('rune-product-page');

  const runeMap = {
    Fehu: 'ᚠ',
    Uruz: 'ᚢ',
    Thurisaz: 'ᚦ',
    Ansuz: 'ᚨ',
    Raidho: 'ᚱ',
    Kenaz: 'ᚲ',
    Gebo: 'ᚷ',
    Wunjo: 'ᚹ',
    Hagalaz: 'ᚺ',
    Nauthiz: 'ᚾ',
    Isa: 'ᛁ',
    Jera: 'ᛃ',
    Eihwaz: 'ᛇ',
    Perthro: 'ᛈ',
    Algis: 'ᛉ',
    Algiz: 'ᛉ',
    Sowilo: 'ᛋ',
    Tiwaz: 'ᛏ',
    Berkano: 'ᛒ',
    Ehwaz: 'ᛖ',
    Mannaz: 'ᛗ',
    Laguz: 'ᛚ',
    Ingwaz: 'ᛜ',
    Othala: 'ᛟ',
    Dagaz: 'ᛞ'
  };

  const swatchBlocks = document.querySelectorAll('.product-form__variants .block-swatch');

  swatchBlocks.forEach((block) => {
    const input = block.querySelector('.block-swatch__radio');
    const label = block.querySelector('.block-swatch__item');

    if (!input || !label) return;

    const runeName = input.value.trim();
    const runeSymbol = runeMap[runeName];

    if (!runeSymbol) return;
    if (label.querySelector('.rune-btn__label')) return;

    // замінюємо текст на структуру
    const text = label.textContent.trim();
    label.textContent = '';

    const textSpan = document.createElement('span');
    textSpan.className = 'rune-btn__label';
    textSpan.textContent = text;

    const symbolSpan = document.createElement('span');
    symbolSpan.className = 'rune-btn__symbol';
    symbolSpan.setAttribute('aria-hidden', 'true');
    symbolSpan.textContent = runeSymbol;

    label.appendChild(textSpan);
    label.appendChild(symbolSpan);

    // анімація при кліку
    label.addEventListener('click', function () {
      if (input.checked) return;

      label.classList.remove('is-rune-animating');
      void label.offsetWidth;
      label.classList.add('is-rune-animating');

      clearTimeout(label._runeTimer);
      label._runeTimer = setTimeout(() => {
        label.classList.remove('is-rune-animating');
      }, 700);
    });
  });
});